if (!customElements.get('product-v2-gallery')) {
  customElements.define(
    'product-v2-gallery',
    class ProductV2Gallery extends HTMLElement {
      constructor() {
        super();
        this.mainSwiper = null;
        this.thumbsSwiper = null;
      }

      connectedCallback() {
        if (typeof Swiper === 'undefined') return;

        const mainEl = this.querySelector('.product-v2-gallery__main');
        const thumbsEl = this.querySelector('.product-v2-gallery__thumbs');

        if (!mainEl) return;

        const slideCount = mainEl.querySelectorAll('.swiper-slide').length;
        if (!slideCount) return;

        if (thumbsEl && slideCount > 1) {
          this.thumbsSwiper = new Swiper(thumbsEl, {
            spaceBetween: 10,
            slidesPerView: Math.min(slideCount, 5),
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
              1: {
                spaceBetween: 8,
                slidesPerView: Math.min(slideCount, 4),
              },
              381: {
                spaceBetween: 8,
                slidesPerView: Math.min(slideCount, 5),
              },
            },
          });
        }

        this.mainSwiper = new Swiper(mainEl, {
          spaceBetween: 0,
          thumbs: this.thumbsSwiper ? { swiper: this.thumbsSwiper } : undefined,
        });
      }

      disconnectedCallback() {
        this.mainSwiper?.destroy(true, true);
        this.thumbsSwiper?.destroy(true, true);
        this.mainSwiper = null;
        this.thumbsSwiper = null;
      }
    }
  );
}
